import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getLogstashPipelinesSaga(
  action: types.GetLogstashPipelinesActionType
) {
  try {
    const response = yield call(
      services.getLogstashPipelinesService,
      action.payload
    );
    if (response.data) {
      log.info("getLogstashPipelinesSaga: GOOD!");
      yield put({ type: actions.GET_LOGSTASH_PIPELINES_SUCCESS, response });
    } else if (response.error) {
      throw response;
    } else {
      log.info("getLogstashPipelinesSaga: BAD!");
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.GET_LOGSTASH_PIPELINES_ERROR, response: error });
  }
}

export function* getLogstashPipelineStatsSaga(
  action: types.GetLogstashPipelineStatsActionType
) {
  try {
    const response = yield call(
      services.getLogstashPipelineStatsService,
      action.payload
    );
    if (response.data) {
      log.info("getLogstashPipelineStatsSaga: GOOD!");
      yield put({
        type: actions.GET_LOGSTASH_PIPELINE_STATS_SUCCESS,
        response,
      });
    } else if (response.error) {
      throw response;
    } else {
      log.info("getLogstashPipelineStatsSaga: BAD!");
      throw response;
    }
  } catch (error) {
    yield put({
      type: actions.GET_LOGSTASH_PIPELINE_STATS_ERROR,
      response: error,
    });
  }
}
